export const scrollToOffset = (element: HTMLElement) => {
    const oneServiceGlobalHeader = document.getElementById("oneservice-global-header-content");
    const targetScrollHeight = element.getBoundingClientRect().y;
    window.scrollTo({
        behavior: "smooth",
        top: window.scrollY + (targetScrollHeight - (oneServiceGlobalHeader?.offsetHeight || 0)),
    });
}